import {
	MapModes,
	ReactMap,
	SourceType,
	tilesConfigCreator,
} from '@innovyze/inno-map';
import React, { ReactElement } from 'react';
import { CustomInfoCard, MapContainer } from './GeneralSettingsFields.styles';

import { useGlobalization } from '@Translations';
import { useAuth0 } from '@innovyze/stylovyze';
import { useReactMapConfig } from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';
import { CompanySettingsFull } from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import { tilesBaseUrl } from '@Apis/tiles.api';
import { assetsBaseUrl } from '@Apis/assets.api';

const DefaultLocation = (): ReactElement => {
	const { token } = useAuth0();
	const { t } = useGlobalization();
	const { values } = useFormikContext<CompanySettingsFull>();
	const setGeneralSettingsFields = useSetGeneralSettingsFields();

	const onBoundsChange = (bounds: number[]) => {
		setGeneralSettingsFields({
			defaultNetworkBoundarySWNELngLat: bounds,
		});
	};

	const reactMapConfig = useReactMapConfig();

	const defaultLocationMap = React.useMemo(
		() => (
			<ReactMap
				config={reactMapConfig}
				disableFitToExtents
				dataServices={[
					{
						type: SourceType.INFO360_TILES_V2,
						id: 'tiles',
						url: tilesBaseUrl,
						token: token,
						attributesUrl: assetsBaseUrl,
					},
				]}
				layerConfig={[
					tilesConfigCreator(
						{
							layerName: t('System Type', {
								context: 'Map layer name',
							}),
							id: 'system_type',
							dataServiceId: 'tiles',
							requestToken: token,
						},
						tilesBaseUrl,
					),
				]}
				mode={MapModes.Search}
				restrictSearchToBounds={false}
				onBoundsChange={onBoundsChange}
			/>
		),
		[reactMapConfig.basemapOrigin, values.mapSettings?.basemapOrigin],
	);
	return (
		<CustomInfoCard fullHeight title={t('Default Location')}>
			<MapContainer>{defaultLocationMap}</MapContainer>
		</CustomInfoCard>
	);
};

export default DefaultLocation;
